import React, { useEffect } from 'react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { WheatDecoration, WheatBorder } from '../ui/WheatDecoration';
import { useSignup } from '../../context/SignupContext';
import { SignupStep } from '../../types';

export const SuccessPage: React.FC = () => {
  const { signupData, setCurrentStep } = useSignup();

  // Redirect if no signup data
  useEffect(() => {
    if (!signupData) {
      setCurrentStep(SignupStep.LANDING);
    }
  }, [signupData, setCurrentStep]);

  if (!signupData) {
    return null;
  }

  const handleStartOver = () => {
    // Reset to landing page for new signup
    setCurrentStep(SignupStep.LANDING);
  };


  return (
    <div className="min-h-screen gradient-bakery flex items-center justify-center px-4 py-8">
      <div className="max-w-md w-full space-y-6 animate-fade-in-up">
        {/* Success Header */}

        {/* Success Details Card */}
        <Card>
          <WheatBorder className="my-6" />
          <div className="text-center">
            <h1 className="text-3xl font-script font-bold text-bakery-darkBrown mb-2">
              Grace & Grain
            </h1>
            <p className="text-bakery-brown mb-6">
              Your phone number has been verified successfully!
            </p>
          </div>

          <div className="space-y-6 px-4">
            <div className="text-center">
              <div className="flex items-center justify-center space-x-3 mb-6">
                <div className="success-checkmark-inline">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <h2 className="text-xl font-serif font-bold text-bakery-darkBrown">
                  Welcome and thanks for joining us, {signupData.fullName}! 🎉
                </h2>
              </div>
            </div>

            <div className="whats-next-section">
              <h3 className="whats-next-title">
                What's Next?
              </h3>
              <div className="wheat-list">
                <div className="wheat-list-item">
                  <WheatDecoration size="sm" />
                  <span>You'll receive a welcome text with instructions on how to place your first order</span>
                </div>
                <div className="wheat-list-item">
                  <WheatDecoration size="sm" />
                  <span>Get daily notifications about fresh-baked items and specials</span>
                </div>
                <div className="wheat-list-item">
                  <WheatDecoration size="sm" />
                  <span>Simply reply to our messages to place orders</span>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <Button
                onClick={handleStartOver}
                variant="outline"
                className="w-full"
              >
                Sign Up Another Number
              </Button>
              <p className="text-xs text-bakery-brown">
                Thank you for joining our cottage bakery family! 
                We can't wait to share our fresh-baked goodness with you.
              </p>
            </div>
          </div>
        </Card>

        {/* Contact Information */}
        <div className="text-center text-sm text-bakery-brown space-y-2">
          <p>Questions? Text us back or call (555) 123-BREAD</p>
          <p className="text-xs">
            To stop receiving messages, reply STOP at any time
          </p>
        </div>
      </div>
    </div>
  );
};
